export default __webpack_public_path__ + "static/media/login-bg.cab16861.png";